import React, { Fragment, useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { Col, Modal, Row } from "react-bootstrap";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import { useNavigate, useParams } from "react-router-dom";
import { formcomptypecreate, formcomptypedelete, formcomptypedetail, formcomptypelist, formcomptypeupdate, schformdetail } from "../../../../services/superadmin";

export const CompetitionList = () => {
    const { id } = useParams();
    const [filterProduct, setFilterProduct] = useState([]);
    const [show, setShow] = useState(false);
    const [ctype, setCType] = useState("");
    const [cpts, setCPts] = useState("");
    const [status, setStatus] = useState("1");
    const [errorMsg, setErrorMsg] = useState("");
    const [fname, setFName] = useState("");
    const navigate = useNavigate();
    const [compid, setCompId] = useState("");

    const sorting = useMemo(() => {
        return ['asc', 'desc',];
    }, []);

    const columnDefs = [
        {
            headerName: "Competition Type",
            field: "competition_type",
            sortable: true,
            resizable: true,
            sorting: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Points",
            field: "competition_points",
            sortable: true,
            resizable: true,
            sorting: true,
            cellStyle: { textAlign: "left" },
        },

        {
            headerName: "Actions",
            field: "id",
            resizable: true,
            filter: false,
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            onClick={() => viewctype(params.value)} title="Edit Competition Type"
                            className="btn-sm btn-secondary me-2"
                        >
                            <i className="fa fa-edit fa-lg"></i>
                        </a>
                        <a
                            onClick={() => deletectype(params)} title="Delete Competition Type"
                            className="btn-sm btn-danger"
                        >
                            <i className="fa fa-trash fa-lg"></i>
                        </a>
                    </div>

                );
            },
        },
    ];

    function viewctype(aid) {
        setShow(true)

        formcomptypedetail(aid).then((response) => {
            if (response.status === true) {
                setCompId(response.data.competition_type.id)
                setCType(response.data.competition_type.competition_type)
                setCPts(response.data.competition_type.competition_points)
                setStatus(response.data.competition_type.status + "")
                dotracking("edit button in competition type for " + response.data.competition_type.competition_type + " (" + aid + ") $$ " + trackobj.formcompheading)
            }
        })
    }

    function deletectype(list) {
        Swal.fire({
            text: "Are you sure want to Delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Delete",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                dotracking(
                    "delete icon in competition type list for " + list.data.competition_type + " (" + list.data.id + ") $$ " + trackobj.formcompheading
                )
                formcomptypedelete(list.data.id).then((response) => {
                    if (response.status === true) {
                        listall();
                        toast.success(response.message)
                    }
                })
            }
        });

    }


    function handleshow() {
        setCType("");
        setCompId("");
        setCPts("");
        setStatus("1");
        setErrorMsg("");
        setShow(true);

    }
    function handleclose() {
        setShow(false);
        setCompId("");
        setCType("");
        setCPts("");
        setStatus("1");
        setErrorMsg("");
    }


    useEffect(() => {
        schformdetail(id).then((res) => {
            if (res.status === true) {
                setFName(res.data.scholarship_form.form_name);
            }
        })
        listall();
    }, []);

    function listall() {
        setFilterProduct([]);
        formcomptypelist(id).then((response) => {
            if (response.status === true) {
                setFilterProduct(response.data.competition_types)
            }
        })
    }

    function Selectstatus(e) {
        setStatus(e.target.value);
    }

    function submitrole(e) {
        e.preventDefault();
        setErrorMsg("")
        if (ctype !== "") {
            if (cpts !== "") {
                const temp = new FormData();
                temp.append("form_details_id", id)
                temp.append("competition_type", ctype)
                temp.append("competition_points", cpts)
                temp.append("status", status)
                if (compid !== "") {
                    temp.append("id", compid);
                    temp.append("updated_by", localStorage.getItem("UID"));
                    dotracking("update button in competition type list for " + ctype + " (" + compid + ") $$ " + trackobj.formcompheading);
                    formcomptypeupdate(temp, compid).then((response) => {
                        if (response.status === true) {
                            handleclose();
                            listall();
                            toast.success(response.message);
                        }
                    })
                } else {
                    temp.append("created_by", localStorage.getItem("UID"));

                    dotracking("add button in competition type list for " + ctype + " $$ " + trackobj.formcompheading);
                    formcomptypecreate(temp).then((response) => {
                        if (response.status === true) {
                            handleclose();
                            listall();
                            toast.success(response.message);
                        }
                    })
                }


            } else {
                setErrorMsg("Please Enter Points")
            }

        } else {
            setErrorMsg("Please Enter Competition Type Name")
        }
    }
    function backlist() {
        dotracking("back button in competition type list for " + fname + " (" + id + ") $$ " + trackobj.schlistheading);
        navigate("/superadmin/scholarshipformlist")
    }
    return (
        <div className="side-app">
            <div className="page-header">
                <div className="breadcrumb">
                    <h4 className="mb-0">Competition Type Lists</h4>
                </div>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Scholarship Form</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Competition Type Lists
                    </li>
                </ol>
            </div>

            <div className="row">
                <div className="col-12">
                    <form className="card mt-0">

                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-7">
                                    <h3>{fname}</h3>
                                </div>
                                <div className="col-md-5">
                                    <div className="text-right">
                                        <a className="btn btn-gray me-2" onClick={backlist}>
                                            <i className="fe fe-corner-up-left"></i> Back
                                        </a>
                                        <a className="btn btn-success" onClick={handleshow}>
                                            <i className="fa fa-plus"></i> Add Competition Type
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="ag-theme-alpine ag-style mt-2">
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    rowData={filterProduct}
                                    pagination="true"
                                    paginationPageSize="10"
                                    sortingOrder={sorting}
                                    suppressExcelExport={true}
                                    suppressDragLeaveHidesColumns={true}
                                    domLayout="autoWidth"
                                    onGridReady={(params) => {
                                        params.api.sizeColumnsToFit();
                                    }}
                                />
                            </div>

                            <Modal show={show} size="lg" onHide={handleclose}>
                                <Modal.Header>
                                    <h4> {compid !== "" ? "Edit" : "Add"} Competition Type</h4>
                                </Modal.Header>
                                <Modal.Body>
                                    <Row className="row-sm mx-0">
                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Competition Type
                                                    <span className="errortext"> *</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Competition Type"
                                                    className="form-control"
                                                    value={ctype}
                                                    onChange={(e) => setCType(e.target.value)}
                                                />
                                            </div>
                                        </Col>

                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Points
                                                    <span className="errortext"> *</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    placeholder="Competition Points"
                                                    className="form-control"
                                                    value={cpts}
                                                    onChange={(e) => setCPts(e.target.value)}
                                                    min="0"
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Status <span className="errortext"> *</span>
                                                </label>

                                                <div className="row" onChange={Selectstatus}>
                                                    <div className="col-md-6">
                                                        <label className="custom-control custom-radio custom-control-md">
                                                            <input
                                                                type="radio"
                                                                className="reg-chk"
                                                                id="active"
                                                                value="1"
                                                                checked={status === "1"}
                                                            />
                                                            {" "} Active
                                                        </label>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="custom-control custom-radio custom-control-md">
                                                            <input
                                                                type="radio"
                                                                className="reg-chk"
                                                                id="active"
                                                                value="0"
                                                                checked={status === "0"}
                                                            />
                                                            {" "}Inactive
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                        </Col>
                                        {errorMsg !== "" && (
                                            <span className="errortext">{errorMsg}</span>
                                        )}
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <a
                                        className="btn btn-danger"
                                        onClick={handleclose}
                                    >
                                        Close
                                    </a>

                                    <a
                                        className="btn btn-success" onClick={submitrole}
                                    >
                                        {compid !== "" ? "Update" : "Submit"}
                                    </a>


                                </Modal.Footer>
                            </Modal>
                        </div>
                    </form>
                </div>
            </div>
        </div>


    );
};
